import { Box, Stack, Typography, Button, Grid, Card } from '@mui/material';
import { gradientTextSx } from '../../../utils/textStyles';

const DefaultDayColumn = ({ dailySchedule, selectedAppointment, onAppointmentClick, displayConfig }) => {
  const date = dailySchedule.date;

  return (
    <Grid key={date} item xs={4} sm={3} md={3} lg={2} data-testid="booking-day" data-date={date}>
      <Card sx={{
        background: displayConfig?.sectionBackground,
        color: displayConfig?.color,
      }}>
        <Stack
          direction={{ xs: "column", xl: "row" }}
          justifyContent="space-around"
          alignItems="center"
          p={1}
          bgcolor="black"
        >
          <Typography variant="h6" textTransform="capitalize" sx={gradientTextSx(displayConfig, displayConfig?.scheduleItemHeaderColor)} noWrap>
            {dailySchedule.weekday}
          </Typography>
          <Typography variant="body1" color="grey.200" noWrap fontSize={{ xs: 12, sm: 14, md: 16 }}>
            {dailySchedule.formattedDate}
          </Typography>
        </Stack>

        <Box sx={{ height: "50vh", overflowY: "auto" }}>
          <Stack p={1} spacing={1}>
            {dailySchedule.timeSlots.map(timeSlot => {
              const isSelected = selectedAppointment?.date === date && selectedAppointment?.time === timeSlot?.startTime;
              return (
                <Button
                  key={`${date}-${timeSlot?.startTime}`}
                  variant={isSelected ? "contained" : "outlined"}
                  color="primary"
                  onClick={() => onAppointmentClick(date, dailySchedule.weekday, timeSlot?.startTime)}
                  sx={{
                    transition: "all 0.2s ease",
                    ...(isSelected && { fontWeight: "bold" }),
                  }}
                >
                  {timeSlot?.startTime}
                </Button>
              );
            })}
          </Stack>
        </Box>
      </Card>
    </Grid>
  );
};

export default DefaultDayColumn;